<template>
  <div class="pagination">
    <div class="page click" v-for="page in start" :key="page" :class="{active: Number(getCurrPage()) === Number(page)}" @click="setPage(page)">
      {{page}}
    </div>
    <div class="page" v-if="center.length || (start.length && width < 601)">...</div>
    <div class="page click" v-for="page in center" :key="page" :class="{active: Number(getCurrPage()) === Number(page)}" @click="setPage(page)">
      {{page}}
    </div>
    <div class="page" v-if="end.length || viewEnd">...</div>
    <div class="page click" v-for="page in end" :key="page" :class="{active: Number(getCurrPage()) === Number(page)}" @click="setPage(page)">
      {{page}}
    </div>
  </div>
</template>


<script>
  export default {
    name: "Pagination",
    props: {
      pages: Number,
      current: Number,
      perPage: {
        type: Number,
        default: 10,
      },
      // dispatch fn coming from every component, where pagination exists
      // then emits to some set function to dispatch other function
      // for example to get data for exact page
      dispatchFn: String
    },
    data() {
      return {
        start: [],
        center: [],
        end: [],
        viewEnd: false
      }
    },
    computed: {
      width() {
        return window.innerWidth
      }
    },
    watch: {
      pages() {
        this.setPage()
      }
    },
    methods: {
      setPage(val) {
        this.start = []
        this.center = []
        this.end = []
        this.viewEnd = false
        const page = val ? val : this.$route.query.page
        const total = Number(this.pages) > this.perPage ? Math.ceil(Number(this.pages) / this.perPage) : 1
        if (total > 5) {
          if (page && (page > 3)) {
            if ((total - 3) < page) {
              if (window.innerWidth > 600) this.start.push(1)
              this.end.push(total - 3)
              this.end.push(total - 2)
              this.end.push(total - 1)
              if (window.innerWidth > 600) this.end.push(total)
            } else {
              if (window.innerWidth > 600) this.start.push(1)
              this.center.push(page - 1)
              this.center.push(page)
              this.center.push(page + 1)
              if (window.innerWidth > 600) {
                this.end.push(total)
              } else {
                this.viewEnd = true
              }
            }
          } else {
            for (let i = 1; i <= total; i++) {
              if (i < 6) this.start.push(i)
              if (i === total && window.innerWidth > 600) this.end.push(i)
            }
          }
        } else {
          this.start = total
        }
        if (page) {
          // emit page number and dispatch fn name came from parent component
          this.$emit('setpage', { page:page , dispatchFn:this.dispatchFn })
        }
      },
      getCurrPage() {
        return this.current === 0 ? 1 : Number(this.current);
      }
    },
    mounted() {
      this.setPage()
    },
  }
</script>


<style lang="scss" scoped>
.pagination{
  @include box(100%, 3vw, relative, null, null, null, null, null, $header);
  box-shadow: $headerShadow;
  z-index: 10;
  @include flex(left, center, row);
  .page{
    @include box(4vw, 3vw, relative, null, 0, 0, null, null, null);
    @include flex(center, center, row);
    @include border(null, solid, $headerBorder, null, null, 0.04vw, null);
    @include text(0.8vw, 500, null, null, center, $headerTitle);
    text-transform: uppercase;
    user-select: none;
    &.click:hover{
      cursor: pointer;
      @include box(5vw, null, null, null, null, null, null, null, $headerHover);
    }
    &.active{
      @include box(5vw, null, null, null, null, null, null, null, $headerHover);
      cursor: default;
    }
  }
}
</style>
